import { Box } from '@mui/material'
import { ButtonIconSeeker } from '@ui-seeker/core'
import React from 'react'
import { groupedExportsModalId } from '../../@signals'

export default function infoColumn() {

	return {
		name: 'id',
		label: 'Info',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { exportUrl }) => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
					<ButtonIconSeeker
						icon="circle-info"
						iconWeight="light"
						onClick={() => groupedExportsModalId.value = value}
						tooltip="More info"
					/>
					{!!exportUrl && <ButtonIconSeeker
						icon="down-to-bracket"
						iconWeight="light"
						tooltip="Export URL"
						onClick={e => {
							if (e.ctrlKey) e.preventDefault()
							window.open(exportUrl)
						}}
					/>}
				</Box>
			),
		},
	}
}
